/**
 * ZooRoyal Account Header.
 */

@use '../../zr-css-icon/zr-css-icon.scss' as i;
@use '../../zr-theme/zr-variables.scss' as *;
@use '../../zr-theme/zr-theme.scss';
@use '../../zr-theme/functions/fonts' as f;

$component: 'zr-loyalty-points-price-info';

:host {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid var(--ci-primary500);
    border-radius: 4px;
    overflow: hidden;
    
    @media only screen and (min-width: $tablet-screen) {
        grid-row: 7/9;
    }
}

.#{$component}__info {
    font-size: 1em;
    font-weight: 700;
    color: var(--ci-primary500);
}

.usp-box {
    border-top: 1px solid var(--ci-primary500);
    width: 100%;
    background-color: var(--ci-primary200);
    text-align: center;
    color: var(--ci-neutral800);
    padding: 8px 16px;
    font-family: 'Museo Sans Rounded', sans-serif;

    h2 {
        margin-top: 0;
        color: var(--ci-neutral800);
        font-family: 'Museo Sans Rounded', sans-serif;
    }
}

.zr-loyalty-points-price-info__wrapper {
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 16px;
}
